import { useSelector } from 'react-redux';

/** Hook validator */
const useAuthorizationValidator = () => {
  const user = useSelector((state) => state.userReducer);
  let role = user.role;

  const checkAccess = (moduleKey) => {
    if (!role) {
      return false;
    }
    /**
     * Get module access
     */
    if (moduleKey) {
      return moduleKey === role;
    }
    return false;
  };

  return {
    checkAccess,
  };
};

export default useAuthorizationValidator;
